import { useState } from 'react';
import { Alert, Button, Form, Input, Typography } from 'antd';
import { LockKeyhole, UserRound } from 'lucide-react';
import { login, type AdminSession } from './api';

export default function LoginPage({ onLogin }: { onLogin: (session: AdminSession) => void }) {
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (values: { username: string; password: string }) => {
    setSubmitting(true);
    setError('');
    try {
      onLogin(await login(values.username, values.password));
    } catch (value) {
      setError(value instanceof Error ? value.message : '登录失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-brand">
        <img src="/yunjing-logo-mark.png" alt="云菁家校" />
        <div><strong>云菁家校</strong><span>平台运营控制台</span></div>
      </section>
      <section className="login-panel">
        <div className="login-heading">
          <Typography.Title level={2}>登录控制台</Typography.Title>
          <Typography.Text type="secondary">仅限受邀的甲方运营与开发运维人员使用</Typography.Text>
        </div>
        {error && <Alert type="error" showIcon title={error} />}
        <Form layout="vertical" requiredMark={false} onFinish={submit}>
          <Form.Item name="username" label="账号" rules={[{ required: true, message: '请输入账号' }]}>
            <Input prefix={<UserRound size={17} />} autoComplete="username" placeholder="请输入后台账号" />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockKeyhole size={17} />} autoComplete="current-password" placeholder="请输入密码" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={submitting}>登录</Button>
        </Form>
        <p className="login-security">连续输错5次将锁定账号15分钟</p>
      </section>
    </main>
  );
}
